// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VenueSummary_venue-summary__XK1ta {
  background-color: var(--light-blue);
  padding: 12px;
  border-radius: 12px;
  display: flex;
  gap: 16px;
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__8er-x {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item__j9p3o {
  padding: 12px 20px 12px 12px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  display: flex;
  align-items: center;
  gap: 12px;
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--icon__S2PNl {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--icon__S2PNl svg {
  width: 32px;
  height: 32px;
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--icon__S2PNl svg path {
  stroke: var(--accent-color-dark);
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--content__VuX8C {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--value__\\+oAgM {
  color: var(--accent-color-dark);
  font-size: 20px;
  font-weight: bold;
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--title__XWFry {
  color: var(--dark-grey);
  font-size: 14px;
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_graph__hLFoC {
  flex: 1 1;
}
.VenueSummary_venue-summary__XK1ta .VenueSummary_graph--item--title__VOaYu {
  font-weight: bold;
}
@media only screen and (max-width: 480px) {
  .VenueSummary_venue-summary__XK1ta {
    flex-direction: column;
    background-color: var(--background-color-2);
  }
  .VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__8er-x {
    gap: 4px;
  }
  .VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item__j9p3o {
    padding: 0;
    border-radius: 0;
    border: 0;
    gap: 4px;
  }
  .VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--icon__S2PNl {
    width: 14px;
    height: 14px;
  }
  .VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--icon__S2PNl svg {
    width: 14px;
    height: 14px;
  }
  .VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--content__VuX8C {
    flex-direction: row;
  }
  .VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--value__\\+oAgM {
    font-size: 14px;
  }
  .VenueSummary_venue-summary__XK1ta .VenueSummary_statistics__item--title__XWFry {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/VenueDetail/Components/VenueSummary/VenueSummary.module.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACI;EACE,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACN;AACM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AACR;AACQ;EACE,WAAA;EACA,YAAA;AACV;AACU;EACE,gCAAA;AACZ;AAIM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAFR;AAKM;EACE,+BAAA;EACA,eAAA;EACA,iBAAA;AAHR;AAMM;EACE,uBAAA;EACA,eAAA;AAJR;AASE;EACE,SAAA;AAPJ;AASM;EACE,iBAAA;AAPR;AAYE;EAnEF;IAoEI,sBAAA;IACA,2CAAA;EATF;EAWE;IACE,QAAA;EATJ;EAUI;IACE,UAAA;IACA,gBAAA;IACA,SAAA;IACA,QAAA;EARN;EAUM;IACE,WAAA;IACA,YAAA;EARR;EAUQ;IACE,WAAA;IACA,YAAA;EARV;EAYM;IACE,mBAAA;EAVR;EAaM;IACE,eAAA;EAXR;EAcM;IACE,eAAA;EAZR;AACF","sourcesContent":[".venue-summary {\n  background-color: var(--light-blue);\n  padding: 12px;\n  border-radius: 12px;\n  display: flex;\n  gap: 16px;\n\n  .statistics {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    &__item {\n      padding: 12px 20px 12px 12px;\n      background-color: #fff;\n      border-radius: 10px;\n      border: 1px solid var(--light-grey);\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      &--icon {\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 9999px;\n\n        svg {\n          width: 32px;\n          height: 32px;\n\n          path {\n            stroke: var(--accent-color-dark);\n          }\n        }\n      }\n\n      &--content {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n      }\n\n      &--value {\n        color: var(--accent-color-dark);\n        font-size: 20px;\n        font-weight: bold;\n      }\n\n      &--title {\n        color: var(--dark-grey);\n        font-size: 14px;\n      }\n    }\n  }\n\n  .graph {\n    flex: 1;\n    &--item {\n      &--title {\n        font-weight: bold;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    flex-direction: column;\n    background-color: var(--background-color-2);\n\n    .statistics {\n      gap: 4px;\n      &__item {\n        padding: 0;\n        border-radius: 0;\n        border: 0;\n        gap: 4px;\n\n        &--icon {\n          width: 14px;\n          height: 14px;\n\n          svg {\n            width: 14px;\n            height: 14px;\n          }\n        }\n\n        &--content {\n          flex-direction: row;\n        }\n\n        &--value {\n          font-size: 14px;\n        }\n\n        &--title {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"venue-summary": `VenueSummary_venue-summary__XK1ta`,
	"statistics": `VenueSummary_statistics__8er-x`,
	"statistics__item": `VenueSummary_statistics__item__j9p3o`,
	"statistics__item--icon": `VenueSummary_statistics__item--icon__S2PNl`,
	"statistics__item--content": `VenueSummary_statistics__item--content__VuX8C`,
	"statistics__item--value": `VenueSummary_statistics__item--value__+oAgM`,
	"statistics__item--title": `VenueSummary_statistics__item--title__XWFry`,
	"graph": `VenueSummary_graph__hLFoC`,
	"graph--item--title": `VenueSummary_graph--item--title__VOaYu`
};
export default ___CSS_LOADER_EXPORT___;
